import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '@/views/home/Home.vue';
import ShareView from '@/views/share/index.vue';
import NoPage from '@/views/nopage/index.vue';
import pageAgreement from '@/views/agreement/index.vue';
import canvas from '@/views/canvas/index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '天星健康'
    }
  },
  {
    path: '/scan/login',
    name: 'scanLoginH5',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/scan/success',
    name: 'scanLoginSuccess',
    component: () => import('@/views/login/success.vue'),
    meta: {
      title: '登录成功'
    }
  },
  {
    path: '/share',
    name: 'share',
    component: ShareView,
    meta: {
      title: '检测报告'
    }
  },
  {
    path: '/useragreement.html',
    name: 'Agreement',
    component: pageAgreement,
    meta: {
      title: '健康镜用户协议'
    }
  },
  {
    path: '/canvas',
    name: 'Canvas',
    component: canvas,
    meta: {
      title: '健康镜用户协议'
    }
  },
  {
    path: '/useragreement',
    name: 'Agreement',
    component: pageAgreement,
    meta: {
      title: '健康镜用户协议'
    }
  },
  {
    path: '/star-applet/yhxy',
    name: 'yhxy',
    component: () => import('@/views/agreement/yhxy.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/star-applet/yszc',
    name: 'yszc',
    component: () => import('@/views/agreement/yszc.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/star-applet/zfxy',
    name: 'zfxy',
    component: () => import('@/views/agreement/zfxy.vue'),
    meta: {
      title: '支付协议'
    }
  },
  {
    path: '/star-applet/zqtys',
    name: 'zqtys',
    component: () => import('@/views/agreement/zqtys.vue'),
    meta: {
      title: '知情同意书'
    }
  },
  {
    path: '/star-applet/call',
    name: 'call',
    component: () => import('@/views/call/index.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/analysis/home',
    name: 'analysisHome',
    component: () => import('@/views/analysis/home.vue'),
    meta: {
      title: '体态评估报告'
    }
  },
  {
    path: '/analysis/page',
    name: 'analysisPage',
    component: () => import('@/views/analysis/page.vue'),
    meta: {
      title: '体态评估报告'
    }
  },
  {
    path: '/analysis/reult',
    name: 'analysisResult',
    component: () => import('@/views/analysis/result.vue'),
    meta: {
      title: '体态评估报告'
    }
  },
  {
    path: '/analysis/reulta',
    name: 'analysisResultA',
    component: () => import('@/views/analysis/resultA.vue'),
    meta: {
      title: '体态评估报告'
    }
  },
  {
    path: '/healthclass/article',
    name: 'healthArticle',
    component: () => import('@/views/healthclass/article.vue'),
    meta: {
      title: '天星健康'
    }
  },
  {
    path: '/device/serial',
    name: 'deviceSerial',
    component: () => import('@/views/device/serial.vue'),
    meta: {
      title: '绑定设备'
    }
  },
  {
    path: '/device/number',
    name: 'deviceNumber',
    component: () => import('@/views/device/number.vue'),
    meta: {
      title: '绑定设备'
    }
  },
  {
    path: '/device/qrcode',
    name: 'deviceQrcode',
    component: () => import('@/views/device/qrcode.vue'),
    meta: {
      title: '绑定设备'
    }
  },
  {
    path: '*',
    name: 'NoPage',
    component: NoPage,
    meta: {
      title: '页面不存在'
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
